<div class="spinner" *ngIf="spinner">
  <div class="body">
    <img [src]="imgSrc" alt="Loading" />
    <div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
